import _get from 'lodash.get'
import { Path, ValueAtPath } from './path.types'

export function get<T extends object, P extends Path<T>>(
  obj: T,
  path: P
): ValueAtPath<T, P> {
  return _get(obj, path)
}
